<template>
  <div id="editor">
    <div class="saveWorkflowDiv">
      <button
          class="btn btn-warning"
          @click="saveWorkflow()"
      >
        저장
      </button>
    </div>

    <!-- 이름설정 -->
    <div class="col-lg-12 col-md-5 col-sm-12">
      <UserEditorName/>
    </div>

    <!-- workflow setting -->
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="text-md-right">
        <button
            class="btn btn-default"
            @click="show('sidebar')"
            id="openCloseBtn"
        >
          =
        </button>
      </div>
      <div class="row clearfix row-deck" style="position: relative;">
        <div class="col-lg-12 col-md-12" >
<!--          :class="{ 'col-xl-8': sidebarStatus }"-->
          <div class="col-lg-12 col-md-12">
            <UserEditorTrigger ref="triggerComponent"/>
          </div>

          <!--            <UserEditorAction-->
          <!--                :propActions="actions"-->
          <!--                :propActionNum="actionNum"-->
          <!--                @addAction="addAction"-->
          <!--            />-->
          <!--          </div>-->
        </div>
        <UserEditorSidebar
            ref="sidebarComponent"
            v-show="sidebarStatus"
            :propactions="actions"
        />
<!--        <div class="col-lg-12 col-md-12" :class="{ 'col-xl-8': sidebarStatus }" v-for="(act, actI)  in actions"-->
<!--             v-bind:key="actI">-->
<!--          <div class="col-lg-12 col-md-12">-->
<!--            actI + 1 : {{ actI }}-->
<!--            <user-editor-action v-bind:actionCount="actI" @addAction="addAction"-->
<!--                                v-on:addedNewAction="addAction" v-on:emitRemoveAction="removeAction"></user-editor-action>-->

<!--          </div>-->
<!--        </div>  -->


<!--        여기 삭제시 순서가 아래부터 삭제됨     -->
<!--        <div class="col-lg-12 col-md-12" :class="{ 'col-xl-8': sidebarStatus }" v-for="(work, workI)  in $store.state.workflowStore.workflowsS"-->
<!--             v-bind:key="workI">-->
<!--          <div class="col-lg-12 col-md-12" v-if="work.type != 'trigger'">-->
            <user-editor-action v-for="(work, workI)  in $store.state.workflowStore.workflowsS" :key="work"  v-bind:actionCount="workI" @addAction="addAction"
                                v-on:addedNewAction="addAction" v-on:emitRemoveAction="removeAction"></user-editor-action>
<!--          </div>-->
<!--        </div>-->

        <!-- sidebar -->
      </div>
    </div>
  </div>
</template>

<script>
import UserEditorTrigger from "@/views/user/editor/UserEditorTrigger";
import UserEditorAction from "@/views/user/editor/UserEditorAction";
import UserEditorName from "@/views/user/editor/UserEditorName";
import UserEditorSidebar from "@/views/user/editor/UserEditorSidebar";
// import eventbus from "@/store/modules/devEventBus";

export default {
  name: "UserEditorPage",
  props: {},
  components: {
    UserEditorTrigger,
    UserEditorAction,
    UserEditorName,
    UserEditorSidebar,
  },
  data() {
    return {
      actions: [],
      actionNum: "",
      showEditAct: false,
      sidebarStatus: false,

      componentKey : 0,
    };
  },
  methods: {
    forceRender(){
      this.componentKey += 1;
    },
    addAction() {
      console.log("액션 추가")
      // 액션 추가
      this.actions.push({
        id: this.actions.length + 1,
        actionNum: "action" + (this.actions.length + 1),
      });
    },
    removeAction(i) {


      // this.actions.splice(i-1, 1);

      var workflows = this.workflowStore.workflowsS;
      workflows.splice(i, 1);

      // this.storeWorkflowsS = workflows

      // for(var j = 0; j < workflows.length; j++) {
      //   workflows[j].index = j;
      // }
      // this.$store.dispatch("buildWorkflows", workflows);
      this.$store.dispatch("saveWorkflowForm", workflows);




      this.updateWorkflow();

    },
    showTrigger() {
      // 트리거 선택 영역 보여주기
      this.showEditTrig = true;
      this.showEditAct = false;
    },
    showAction(name) {
      // 액션 선택 영역 보여주기
      this.actionNum = name;
      this.showEditAct = true;
      this.showEditTrig = false;
    },
    show(name) {
      console.log(name);
      if (name == "sidebar") {
        this.sidebarStatus = !this.sidebarStatus;
      }
    },
    buildWorkflows() {
      const workflows = [];
      const tObj = {type: "trigger", index: 0};
      const aObj = {type: "action", index: 1};

      tObj.authentication = JSON.parse(
          JSON.stringify(this.workflowStore.authenticationS)
      );
      tObj.api = JSON.parse(JSON.stringify(this.workflowStore.apiS));

      aObj.authentication = JSON.parse(
          JSON.stringify(this.workflowStore.authenticationS)
      );
      aObj.api = JSON.parse(JSON.stringify(this.workflowStore.apiS));

      workflows.push(tObj);
      workflows.push(aObj);

      this.$store.dispatch("buildWorkflows", workflows);
    },

    buildAppNames() {
      const workflows = this.workflowStore.workflowsS;
      const names = [];

      for (var i = 0; i < workflows.length; i++) {
        names.push(JSON.parse(JSON.stringify({code: "", name: ""})));
      }

      this.$store.dispatch("buildAppNames", names);
    },
    buildSelectedApps() {
      const workflows = this.workflowStore.workflowsS;
      const names = this.workflowStore.appNames;

      for (var i = 0; i < workflows.length; i++) {
        names.push({code: workflows[i].api.appCode, name: ""});
      }
    },
    saveWorkflow() {

      if(this.workflowStore.workflowName.replace(/^\s+|\s+$/gm, "") == "") {
        alert("워크플로우명을 입력해 주세요.");
        return;
      }

      var param = {
        workflowCode: this.workflowStore.workflowCode,
        workflowName: this.workflowStore.workflowName,
        groupCode: this.workflowStore.groupCode,
        insertDt: "",
        workflows: JSON.stringify(this.workflowStore.workflowsS),
      };
      this.api.updateWorkflow(param).then((res) => {
        console.log("updateWorkflow res : ", res);
        if (res["code"] == 0) {
          this.$router.push({name: "WorkflowPage"})
        }
      });
    },
    async updateWorkflow() {
      var param = {
        workflowCode: this.workflowStore.workflowCode,
        workflowName: this.workflowStore.workflowName,
        groupCode: this.workflowStore.groupCode,
        insertDt: "",
        workflows: JSON.stringify(this.workflowStore.workflowsS),
      };

      const res = await this.api.updateWorkflow(param);
      console.log("updateWorkflow res : ", res)

      return res;

    },
    // getAllApiList() {
    //   var param = {};
    //   this.api.getAllApiList(param).then((res) => {
    //     console.log("getAllApiList res : ", res);
    //     if (res["code"] == 0) {
    //       this.$store.dispatch("saveAllApis", res.apis);
    //     }
    //   });
    // },
    getGroupList() {
      var param = {userCode: this.userStore.userCode};
      this.api.getGroupList(param).then((res) => {
        console.log("getGroupList res : ", res);
        if (res["code"] == 0) {
          this.$store.dispatch("saveGroups", res.groups)
        }
      });
    },
    saveHomeGroupCode() {
      const groups = this.workflowStore.groups;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].groupName == "Home") {
          this.$store.dispatch("saveGroupCode", groups[i].groupCode);
        }
      }
    },
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
    storeWorkflowsS() {
      return this.$store.state.workflowStore.workflowsS
    }
  },

  created() {
    console.log("UserEditorPage.created");
    this.getGroupList();

    if (this.$route.params.editType == "new") {
      // this.buildWorkflows();
      this.saveHomeGroupCode();
      // this.actions.push({id: 1, actionNum: "action1"})
    } else {

      const workflows = this.workflowStore.workflowsS;
      this.actions = [];


      for(var i = 0; i < workflows.length; i++) {
        this.actions.push({
          id: i + 1,
          actionNum: "action" + (i + 1),
        });
      }


    }

    this.$store.dispatch("changeNowWorkCode", "");


    // eventbus.$once("resetApiDetail", (num)=>{
    //
    //   if(num == 0){
    //     eventbus.$emit("getAuthListsTrigger")
    //   } else {
    //
    //     eventbus.$emit("getAuthListAction" + num)
    //   }
    //
    // })



    // api 전체 리스트 조회
    // this.getAllApiList();
  },
  mounted() {
    console.log("UserEditorPage.mounted");
  },
  beforeDestroy() {
    console.log("UserEditorPage.beforeDestroy");
    this.$store.state.userStore.testData = []
  }
}
</script>

<style scoped>
@import "../../../assets/css/user/user-editor.css";
</style>
